const loc = window.location
const baseURL = `${loc.protocol}//${loc.hostname}${
    loc.hostname === "localhost" ? ":3001/api" : "/api"
}`

export default baseURL
